export default function TabButton({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 rounded-full px-3 py-1.5 font-medium border transition-colors
        ${active ? "bg-white border-slate-300 text-slate-900" : "bg-slate-50 border-slate-200 text-slate-600 hover:bg-white"}`}
    >
      {children}
    </button>
  );
}
